<template>
  <ElButton
    type="game"
    @click="showDialog()"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <ElDatePicker
          v-model="updateExpiration"
          style="width: 100%;"
          :picker-options="datepickerOptions"
          type="date"
          format="dd-MM-yyyy"
        />
        <Spacer />
        <el-checkbox v-model="sendEmail" label="Send Email Notification"></el-checkbox>
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="expirationDate === updateExpiration"
          @click="changeExpirationDate()"
        >
          Submit
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'ExtendAccount',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      updateExpiration: null,
      sendEmail: true,
      datepickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      }
    }
  },
  computed: {
    title() {
      return 'EXTEND ACCOUNT'
    },

    profile() {
      return this.user.profile
    },

    expirationDate() {
      return this.profile.expirationDate
    }
  },
  methods: {
    showDialog() {
      this.updateExpiration = this.expirationDate
      this.showForm = true
    },

    changeExpirationDate() {
      const data = {
        profileId: this.profile.id,
        date: this.updateExpiration,
        sendEmail: this.sendEmail
      }

      return axios.post('admin/extend-account', data)
        .then(res => {
          const updateData = {
            id: this.user.id,
            expirationDate: this.updateExpiration.toString()
          }

          if (this.profile.status !== 'PAID') {
            updateData.status = 'FREE'
          }

          this.$store.commit('updateRecruiterProfile', updateData)

          this.showForm = false

          this.successNotification(res.data)
        })
        .catch(axios.handleError)
    }
  }
}
</script>
